import { api } from '../../core/api-client';

export type TicketTopic  = 'general' | 'billing' | 'technical' | 'feature';
export type TicketStatus = 'open' | 'pending' | 'closed';

export interface SupportTicket {
  id: string; tenant_id: string | null; created_by_user_id: string | null;
  contact_name: string; contact_email: string; subject: string;
  topic: TicketTopic; status: TicketStatus;
  created_at: string; updated_at: string; last_activity_at: string;
}
export interface SupportMessage {
  id: string; ticket_id: string; author_type: 'user' | 'admin';
  author_name: string; author_email: string | null; body: string; created_at: string;
}

export const tenantSupportApi = {
  list: () => api<{ tickets: SupportTicket[] }>('/api/support/tickets').then((r) => r.tickets),
  get:  (id: string) => api<{ ticket: SupportTicket; messages: SupportMessage[] }>(`/api/support/tickets/${id}`),
  create: (input: { subject: string; topic: TicketTopic; message: string }) =>
    api<{ ticket: SupportTicket }>('/api/support/tickets', { method: 'POST', body: input }).then((r) => r.ticket),
  reply: (id: string, message: string) =>
    api<{ message: SupportMessage }>(`/api/support/tickets/${id}/messages`, { method: 'POST', body: { message } }).then((r) => r.message),
};

export const adminSupportApi = {
  list: (status?: TicketStatus) =>
    api<{ tickets: SupportTicket[] }>(`/api/super-admin/support/tickets${status ? `?status=${status}` : ''}`).then((r) => r.tickets),
  get:  (id: string) => api<{ ticket: SupportTicket; messages: SupportMessage[] }>(`/api/super-admin/support/tickets/${id}`),
  reply: (id: string, message: string) =>
    api<{ message: SupportMessage }>(`/api/super-admin/support/tickets/${id}/messages`, { method: 'POST', body: { message } }).then((r) => r.message),
  setStatus: (id: string, status: TicketStatus) =>
    api<{ ticket: SupportTicket }>(`/api/super-admin/support/tickets/${id}`, { method: 'PATCH', body: { status } }).then((r) => r.ticket),
};
